// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fd8I","right":"styles_right__1n9IF"};